import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarDoorFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.33087 5.66412C9.78106 5.21393 10.4144 4.87793 11.0986 4.87793H19.9158V18.8637H3.49768V13.0262C3.49768 12.33 3.73455 11.704 4.19134 11.1711L4.1997 11.1613L9.32348 5.67151L9.33087 5.66412ZM6.42554 11.1798H18.2758V6.51794H11.0986C10.9122 6.51794 10.6792 6.63513 10.4906 6.82373L6.42554 11.1798ZM6.38965 13.7062H8.79004V15.3468H6.38965V13.7062Z"
      />
    </SvgIcon>
  );
});
